import { useContext } from "react";
import { ProvinceListContext } from "../contexts/ProvinceListContext";

function useProvince() {
    return useContext(ProvinceListContext);
}

export default useProvince